import { useSelector, useDispatch } from "react-redux";

import { useEffect } from "react";

import Toast from "./components/common-components/Toast";
import Index from "./app/routes/Index";
import { AppDispatch, RootState } from "./stores/store";
import { clearToast, ToastState } from "./stores/toast/toastslice";


function App() {
  const toast = useSelector(
    (state: RootState) => state.toast as ToastState | null,
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => dispatch(clearToast()), 3000);
      return () => clearTimeout(timer);
    }
  }, [toast, dispatch]);

  return (
    <>
      {toast && (
        <div
          style={{
            position: "fixed",
            top: "80px",
            right: "10px",
            zIndex: 8000,
          }}
        >
          <Toast
            message={toast.message}
            type={toast.type}
            title={toast.title ?? ""}
            onClose={() => dispatch(clearToast())}
          />
        </div>
      )}

      <Index />
    </>
  );
}

export default App;
